import { extendZodWithOpenApi } from '@anatine/zod-openapi'
import z from 'zod'

extendZodWithOpenApi(z)

export const JobStatus = {
  PENDING: 'pending',
  DEPRIORITISED: 'deprioritised',
  BACKLOG: 'backlog',
  QUEUED: 'queued',
  IN_PROGRESS: 'in_progress',
  PACKED: 'packed',
  PALLETISED: 'palletised',
  PAUSED: 'paused',
  UNPAUSED: 'unpaused',
  ON_HOLD: 'on_hold',
  CANCELLED: 'cancelled',
  /**
   * Never set directly by a Phoenix service. Today it's written only by the
   * lyka-migrations CDC pipeline for legacy Laravel orders that reached their
   * delivery date, and by the E2E fulfilment seed. Going forward the planned
   * scheduler is the source: it promotes PALLETISED orders past their
   * delivery_date to DELIVERED, and that transition is what drives the
   * `order.delivered:invoice` NetSuite outbox row (OPS-2909).
   */
  DELIVERED: 'delivered',
} as const
export type JobStatus = typeof JobStatus[keyof typeof JobStatus]

export const PaymentStatus = {
  PENDING: 'pending', // init charge
  PROCESSING: 'processing', // attempting charge
  ATTEMPT_FAILED: 'attempt_failed', // Failed charge - Retryable
  PROCESSED: 'processed', // Successful charge - Eventual State
  EXPIRED: 'expired', // Failed - Eventual State - No Retry - Deprecated for FAILED status
} as const
export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus]

export const DeliverySlotWindow = {
  AM: 'AM',
  PM: 'PM',
} as const
export type DeliverySlotWindow = typeof DeliverySlotWindow[keyof typeof DeliverySlotWindow]

export const AddressState = {
  ACT: 'ACT',
  NSW: 'NSW',
  NT: 'NT',
  QLD: 'QLD',
  SA: 'SA',
  TAS: 'TAS',
  VIC: 'VIC',
  WA: 'WA',
} as const
export type AddressState = typeof AddressState[keyof typeof AddressState]

export const RebalancingStatus = {
  NOT_APPLICABLE: 'not_applicable',
  QUEUED: 'queued',
  PROCESSED: 'processed',
} as const
export type RebalancingStatus = typeof RebalancingStatus[keyof typeof RebalancingStatus]

export const OrderComplaintResponsibility = {
  BeCool: 'BeCool',
  Production: 'Production',
  Fulfillment: 'Fulfillment',
}

export const OrderComplaintResponsibilitySchema = z.nativeEnum(OrderComplaintResponsibility)
export type OrderComplaintResponsibility = z.infer<typeof OrderComplaintResponsibilitySchema>
